export const API_ENDPOINTS = {
  ADMIN_EVENTS: {
    FETCH_EVENT: () => `/events`,
    FETCH_EVENT_FOR_EMP: (key) => `/events/all-attendees?month=${key}`,
    FETCH_EVENT_FOR_EMP_YEAR: (key) => `/events/all-attendees?year=${key}`,
    FETCH_EMPLOYEE_CURSOR: (cursor) =>
      `/employee/options?size=10&cursor=${cursor}`,
    FETCH_ATTENDEES: (key) => {
      const params = Array.isArray(key)
        ? key.map((k) => `key=${encodeURIComponent(k)}`).join("&")
        : `key=${encodeURIComponent(key)}`;
      return `/events/attendees?${params}`;
    },

    ADD_EVENTS: () => "/events",
    EDIT_EVENTS: (id) => `/events?id=${id}`,
    DELETE_EVENTS: (id) => `/events/${id}`,
    FETCH_EVENT_BY_PARAMS: (params) => {
      const { emp, category, type, month } = params;
      const queryParams = new URLSearchParams();
      if (emp) queryParams.append("employee", emp);
      if (category) queryParams.append("category", category);
      if (type) queryParams.append("eventType", type);
      if (month) queryParams.append("month", month);
      const queryString = queryParams.toString();
      return queryString ? `/events?${queryString}` : `/events`;
    },
  },
};
